module.exports = __webpack_public_path__ + "components/flag/static/square/vc-dfc7094cebc3c81a794cc2668e3eb7d9.svg";